import { ReactElement } from 'react';
import { Modal as AntModal, ModalProps } from 'antd';

export const Modal = (props: ModalProps): ReactElement => <AntModal {...props} />;
